<template>
  <div class="mfe-section">
    <BookmarksList />
  </div>
</template>

<script>
import BookmarksList from '@/components/MyBookmarks/BookmarksList';

export default {
  name: 'MyBookmarksMfe',
  components: {
    BookmarksList
  }
};
</script>
